module.exports = __webpack_public_path__ + "img/ctrl-a-stub-down-+.185f12d5.svg";